function TeamsPageSubmenu({ renderItems, translate }) {
  return renderItems([
    { label: translate('teams'), link: 'teams' },
    { label: translate('missions'), link: 'missions' },
    { label: translate('sectors'), link: 'sectors', disabled: true },
  ]);
}

export default TeamsPageSubmenu;
